import { useSetRecoilState } from 'recoil';
import { progressBarValues } from '../states/globalAppProgressBar';
import { useEffect, useRef, useState } from 'react';

const getNextId = (): number => (Math.random() * 1e6) | 0;

export function useGlobalAppLoadingBar(initialLoadingState: boolean | number = false, resetOnUnmount = true) {
    const setValues = useSetRecoilState(progressBarValues);
    const idRef = useRef(getNextId());
    const [value, setValue] = useState<number | boolean>(initialLoadingState);

    useEffect(() => {
        setValues(currentValues => {
            const newValues = new Map(currentValues);

            if (!value || value >= 100)
                newValues.delete(idRef.current);
            else
                newValues.set(idRef.current, value);

            return newValues;
        });
    }, [value]);

    useEffect(() => {
        return () => {
            if (resetOnUnmount) {
                setValues(currentValues => {
                    const newValues = new Map(currentValues);

                    newValues.delete(idRef.current);

                    return newValues;
                });
            }
        };
    }, []);

    return {
        value,
        setValue,
    };
}
